import modelBaseV2 from "../model-base-v2.model";

const SellInInvoiceVsImeiScanCountModel = {
  search: (criteria = {}) => {
    return modelBaseV2.post("/api/imei-reports/imei-scan-count-summary", {
      body: { ...criteria, isExcelDownload: false },
    });
  },

  exportSummaryExcel: (criteria = {}) => {
    return modelBaseV2.postDownload(
      "/api/imei-reports/imei-scan-count-summary",
      {
        body: { ...criteria, isExcelDownload: true },
      },
      "Summary - Sell In Invoice vs IMEI Scan Count"
    );
  },

  exportRawData: (config = {}) => {
    return modelBaseV2.postDownload(
      "/api/imei-reports/imei-scan-count-raw",
      {
        body: config,
      },
      "RawData - Sell In Invoice vs IMEI Scan Count"
    );
  },

  getDivisions: () => {
    return modelBaseV2.get("/api/division/getdivision");
  },
};

export default SellInInvoiceVsImeiScanCountModel;
